export const DEFAULT_IMAGE_MODEL = 'realvis-xl-v4';

export const DEFAULT_IMAGE_ASPECT_RATIO = '1_1';

export const IMAGE_ASPECT_RATIO = {
  '1_1': '1_1',
  '16_9': '16_9',
  '9_16': '9_16',
  '4_3': '4_3',
};

export const IMAGE_ASPECT_RATIO_TEXT = {
  [IMAGE_ASPECT_RATIO['1_1']]: 'Square 1:1',
  [IMAGE_ASPECT_RATIO['16_9']]: 'Landscape 16:9',
  [IMAGE_ASPECT_RATIO['9_16']]: 'Portrait 9:16',
  [IMAGE_ASPECT_RATIO['4_3']]: 'Wide 4:3',
};
